import { REQUEST_CALLBACK_REL } from './constants'

export const requestAnnualCallbackRelSelector = (state) =>
  state.links.filter((link) => link.Rel === REQUEST_CALLBACK_REL)[0]

export const getPolicy = (state) => state.policy
